import { yupResolver } from '@hookform/resolvers/yup'
import { useForm } from 'react-hook-form'
import { myCompanyFormSchema } from './my-company-form.schema'

export const useMyCompanyForm = () => {
  const form = useForm({
    resolver: yupResolver(myCompanyFormSchema),
    defaultValues: myCompanyFormSchema.cast({}),
  })

  return form
}
